import Medusa from '@adoratorio/medusa';

const medusa = {
  ref: null,

  init() {
    medusa.ref = new Medusa();
  },
};

export default medusa;
